/** @format */
import { decimalToCent } from '@toucan/client/global/currency';
import { productConditionStringToEnum } from '@toucan/client/global/product';

import {
    Basket,
    BasketItem,
    MPBXBasket,
    MPBXBasketItem,
} from '../config/types';

export function serializeBasketItem(
    mpbxBasketItem: MPBXBasketItem
): BasketItem {
    return {
        id: mpbxBasketItem.product.id,
        modelId: mpbxBasketItem.product.modelId,
        sku: mpbxBasketItem.product.sku,
        name: mpbxBasketItem.product.name ?? mpbxBasketItem.product.modelName,
        condition: productConditionStringToEnum(
            mpbxBasketItem.product.condition
        ),
        modelSlug: mpbxBasketItem.product.modelSlug,
        value: decimalToCent(parseFloat(mpbxBasketItem.product.listPrice)),
        imageUrl: mpbxBasketItem.product.images?.[0]?.imageUrl ?? '',
        availability: mpbxBasketItem.availability,
        itemSku: mpbxBasketItem.sku,
        listPrice: mpbxBasketItem.listPrice,
    };
}

export function serializeBasket(mpbxBasket: MPBXBasket): Basket {
    return {
        items: mpbxBasket.items.map(serializeBasketItem),
        currency: mpbxBasket.currency,
    };
}
